var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-bg-image"},[_c('div',{staticClass:"content-image"},[_c('img',{attrs:{"src":require("@/assets/images/fixed-image-login.png")}})]),_c('img',{staticClass:"image-float",attrs:{"src":require("@/assets/images/float-image-login.png")}})])
}]

export { render, staticRenderFns }